import { useQueryClient } from '@tanstack/react-query';

import {
  getApiV1PersonIdQueryOptions,
  getApiV1PersonQueryOptions,
  usePatchApiV1PersonIdActivate,
  usePatchApiV1PersonIdDeactivate,
} from '@/shared/api/generated';

/**
 * Hook para ativar e desativar uma pessoa.
 *
 * Invalida a listagem e o detalhe da pessoa após cada operação.
 *
 * @example
 * ```tsx
 * const { activate, deactivate } = useTogglePersonStatus();
 * activate.mutate({ id: 1 });
 * deactivate.mutate({ id: 1 });
 * ```
 */
export function useTogglePersonStatus() {
  const queryClient = useQueryClient();

  const invalidate = (id: number) => {
    void queryClient.invalidateQueries(getApiV1PersonQueryOptions());
    void queryClient.invalidateQueries(getApiV1PersonIdQueryOptions(id));
  };

  const activate = usePatchApiV1PersonIdActivate({
    mutation: {
      onSuccess: (_data, variables) => invalidate(variables.id),
    },
  });

  const deactivate = usePatchApiV1PersonIdDeactivate({
    mutation: {
      onSuccess: (_data, variables) => invalidate(variables.id),
    },
  });

  return { activate, deactivate } as const;
}
